export default "__VITE_ASSET__7fd7e001__"